import React, { Component } from 'react';
import css from './style.css';
import cs from 'classnames';

export default class SortSelect extends Component {
  render() {
    const { sortText, sortType, sortHandler, ...rest } = this.props;

    return (
      <span onClick={sortHandler} {...rest}>
        {sortText}
        {sortType}
        {
          <img
            className={cs(css.sortIcon, {
              [css.sortHide]: sortType === undefined,
            })}
            src='/assets/ratio-sort-default.svg'
          />
        }
        {
          <img
            className={cs(css.sortIcon, {
              [css.sortHide]: sortType === true,
            })}
            src='/assets/ratio-sort-up.svg'
          />
        }
        {
          <img
            className={cs(css.sortIcon, {
              [css.sortHide]: sortType === false,
            })}
            src='/assets/ratio-sort-down.svg'
          />
        }
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioList/SortSelect/index.js